<template>
  <ion-list v-if="resources.data.billFees != null">
    <ion-list-header>
      <p>Fees</p>
    </ion-list-header>
    <ion-item
      class="hydrated link"
      v-for="item in resources.data.billFees.data"
      :key="item.id"
      :ref="`items-${item.id}`"
    >
      <ion-label>
        <h2>{{ item.fee.name }}</h2>
        <p>Net Amount: Rs {{ item.amount_in_cent / 100 }}</p>
        <p>Net Tax: Rs {{ item.tax_in_cent / 100 }}</p>
        <p>Gross Amount: Rs {{ item.gross_amount_in_cent / 100 }}</p>
      </ion-label>
      <ion-button
        slot="end"
        fill="clear"
        :href="`${base_url}api/v1/bill-fee-export/${item.id}?pat=${token}`"
        :download="`billing_fee_${item.fee.name}`"
      >
        <ion-icon
          slot="icon-only"
          :ios="downloadOutline"
          :md="downloadSharp"
        ></ion-icon>
      </ion-button>
    </ion-item>
  </ion-list>
  <ion-list v-else>
    <ion-list-header>
      <p>No billFees found</p>
    </ion-list-header>
  </ion-list>
</template>
<script>
import {
  IonList,
  IonListHeader,
  IonLabel,
  IonItem,
  IonButton,
  IonIcon,
} from "@ionic/vue";

import { downloadOutline, downloadSharp } from "ionicons/icons";
import base_url from "../../../../apis/base_url";

export default {
  props: {
    resources: {
      type: Object,
      required: true,
    },
  },

  components: {
    IonList,
    IonListHeader,
    IonLabel,
    IonItem,
    IonButton,
    IonIcon,
  },
  data() {
    return {
      downloadOutline,
      downloadSharp,

      base_url,
    };
  },

  computed: {
    token(){
      return this.$store.getters['auth/token']
    }
  },
};
</script>